import { IStatusConfig } from '../../../components/StatusBadge'
import { ESupportTicketStatus } from '../../../services/Support/interfaces'

/**
 * Status do chamado. Fica no módulo porque só existe aqui, mas na forma `{ label, colorScheme }`
 * que o `<StatusBadge>` lê: o ternário `status === OPEN ? 'Aberto' : 'Concluído'` estava escrito
 * duas vezes na listagem e duas na ficha, com a cor num ternário separado do rótulo, e a lista de
 * opções do filtro era uma terceira cópia dos mesmos dois rótulos.
 */
export const SUPPORT_TICKET_STATUS: Record<ESupportTicketStatus, IStatusConfig> = {
  [ESupportTicketStatus.OPEN]: { label: 'Aberto', colorScheme: 'yellow' },
  [ESupportTicketStatus.RESOLVED]: { label: 'Concluído', colorScheme: 'green' }
}
